import { useState } from 'react';
import { IconButton, PersonAvatar, Button } from '@teo/components';
import { CrossFilled, ArrowLeft, ArrowRight } from '@teo/components/icons';
import { useNavigate } from 'react-router-dom';
import { newUid, nthLastIndexOf } from '@/util';
import { useTranslation } from 'react-i18next';
import { useGet } from '@/query/fetchHooks';

const CorrectionHeader = ({
  learningpath,
  lpgroupId,
  student,
  authUser,
  setRefresh,
}) => {
  const navigate = useNavigate();

  const [nextCorrection, setNextCorrection] = useState(null);
  const [previousCorrection, setPreviousCorrection] = useState(null);

  const { t } = useTranslation();

  const basePath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 3)
  );
  const userPath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 4)
  );
  const stepPath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 1)
  );

  useGet(`/mylpfollows`, {
    userId: authUser?.id,
    organisationId: authUser?.activeOrganisationId,
    lpgroupId: lpgroupId,
    sort: 'username,lpProgress',
    onSuccess: async (res) => {
      if (res?.data?.length > 0) {
        const index = res?.data.findIndex(
          (item) => item.studentId === student?.studentId
        );
        const prev = index > 0 ? res?.data[index - 1] : null;
        const next = index < res?.data.length - 1 ? res?.data[index + 1] : null;
        setNextCorrection(next?.studentId);
        setPreviousCorrection(prev?.studentId);
      }
    },
  });

  return (
    <>
      <div className="flex items-center justify-between border-b border-solid border-grey-02 bg-white px-5 py-4">
        <div className="flex w-full flex-col items-center sm:flex-row">
          <div className="flex flex-row items-center">
            <div className="flex items-center">
              <IconButton
                className="my-auto mx-2"
                Icon={CrossFilled}
                variant="ghost"
                onClick={() => navigate(`${basePath}/details/${lpgroupId}`)}
              />
              <div className="mr-2 w-20 min-w-20 sm:mr-5">
                <img
                  src={
                    learningpath?.lpgroupPicture ||
                    learningpath?.lpPicture ||
                    '/assets/images/LearnPath.png'
                  }
                  alt={learningpath?.lpName}
                  className="h-12 rounded-lg"
                />
              </div>
            </div>
            <div className="ml-1 flex flex-wrap items-center sm:mt-2 sm:ml-10 sm:ml-0 sm:mt-0 sm:pl-3 sm:pl-0">
              <span className="pr-2 sm:min-w-max">
                {t('pages.lp_correction.header_title')}
              </span>
              <span className=" font-semibold">
                {learningpath?.lpgroupName || learningpath?.lpName}
              </span>
            </div>
          </div>

          <div className="mx-auto mt-4 sm:mt-0 sm:ml-auto">
            <Button
              onClick={() => navigate(`${basePath}/details/${lpgroupId}`)}
              variant="outline"
              className="flex items-center"
            >
              {t('pages.lp_correction.go_to_lp')}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>

      <div className="flex items-center border-b py-4 px-5">
        <div className="flex w-[50px] flex-row items-center sm:w-[270px]">
          {previousCorrection && (
            <>
              <IconButton
                Icon={ArrowLeft}
                ariaLabel={t('pages.lp_correction.prev_student')}
                onClick={() => {
                  navigate(`${stepPath}/${previousCorrection}`);
                  setRefresh(true);
                }}
                variant="outline"
              />
              <p className="ml-3 hidden w-max lg:block">
                {t('pages.lp_correction.prev_student')}
              </p>
            </>
          )}
        </div>

        <div className="mx-auto flex flex-col items-center gap-2 sm:flex-row sm:gap-0">
          <PersonAvatar
            inline
            id={student?.studentId}
            name={student?.username}
            imageSrc={student?.picture}
          ></PersonAvatar>
          <p className="mr-3 font-semibold">{student?.username}</p>
          <Button
            onClick={() => navigate(`${userPath}/users/${student?.studentId}`)}
            variant="outline"
            size="sm"
            className="flex items-center"
          >
            {t('pages.correction_result.btn_user')}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
        <div className="flex w-[50px] flex-row items-center justify-end sm:w-[270px]">
          {nextCorrection && (
            <>
              <p className="mr-3 hidden w-max lg:block">
                {t('pages.lp_correction.next_student')}
              </p>
              <IconButton
                Icon={ArrowRight}
                ariaLabel={t('pages.lp_correction.next_student')}
                onClick={() => {
                  navigate(`${stepPath}/${nextCorrection}`);
                  setRefresh(true);
                }}
                variant="outline"
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CorrectionHeader;
